// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuthorPostGrid--wrapper--1kAlP"};